import React from 'react';

import styles from './ViewDataTable.css';

const ViewDataTable = ({
    modalId,
    dataDescriptor = '',
    audioLabel = '',
    children
}) => {
    const openModal = () => {
        const modal = document.querySelector(`#${modalId}`);
        if (modal !== null) modal.show();
    };

    // add a space character to the dataDescriptor if it has a text value w/ a length
    const extraButtonText =
        dataDescriptor && dataDescriptor.length ? `${dataDescriptor} ` : '';

    return (
        <>
            <div className="data-btn-wrapper">
                <frt-beacon-button
                    variant="tertiary"
                    size="normal"
                    label={`View ${extraButtonText}Data`}
                    onClick={openModal}
                    aria-label={audioLabel}
                    aria-controls={modalId}
                />
            </div>
            <div className="chart-table-wrapper">
                <div className="data-content">
                    <frt-beacon-modal
                        id={modalId}
                        scale="jumbo"
                        elevation="3"
                        close-on-click-out
                    >
                        <div className="beacon-modal__media">
                            {!children ? (
                                <p className="data-error-text">No Data</p>
                            ) : (
                                <frt-beacon-table>{children}</frt-beacon-table>
                            )}
                        </div>
                    </frt-beacon-modal>
                </div>
            </div>
            <style jsx>{styles}</style>
        </>
    );
};

export default ViewDataTable;
